export default __webpack_public_path__ + "static/media/Background_00061.274c4172.png";